import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";

import { DefaultHeaderCell } from "../../../../Layout/SortedList";
import { checkIsInternalUser } from "../../../../../helpers/Authorization/authorizationHelpers";

class ListHeader extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    sort: PropTypes.object
  };

  static defaultProps = {
    sort: {}
  };

  handleClick = keyName => this.props.onClick(keyName);

  render() {
    const isInternal = checkIsInternalUser();
    return (
      <div role="row" tabIndex="0" className="sorted-list__row-header">
        <DefaultHeaderCell
          className="--first --x3"
          keyName="customerPOId"
          label={i18n.t(`purchaseOrder.number`)}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        {isInternal && (
          <DefaultHeaderCell
            className="--x1"
            keyName="mills"
            label={i18n.t(`purchaseOrder.mill`)}
            sortedColumn={this.props.sort.keyName}
            sortDirection={this.props.sort.direction}
            onClick={this.handleClick}
          />
        )}
        <DefaultHeaderCell
          className="--x3"
          keyName="soldTo.customerName"
          label={i18n.t("purchaseOrder.soldTo")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--x3"
          keyName="shipTo.customerName"
          label={i18n.t("purchaseOrder.shipTo")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--x2"
          keyName="endUserId"
          label={i18n.t("purchaseOrder.endUser")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--x2"
          keyName="pricingPeriodDate"
          label={i18n.t("purchaseOrder.poPeriod")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--right --x2"
          keyName="quantityAcknowledged.value"
          label={i18n.t("purchaseOrder.ordered")}
          tooltipContent={i18n.t("tooltip.ordered")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--right --x2"
          keyName="quantityShipped.value"
          label={i18n.t("purchaseOrder.shipped")}
          tooltipContent={i18n.t("tooltip.shipped")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--right --x2"
          keyName="quantityRemaining.value"
          label={i18n.t("purchaseOrder.remaining")}
          tooltipContent={i18n.t("tooltip.remaining")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
      </div>
    );
  }
}

export default ListHeader;



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/ListPage/List/Tracking/ListHeader.js